
const NavHeader = () => {

    return <div className="nav-header">
        <a href="#" className="brand-logo">
            <img className="logo-abbr" src="/images/logo_studict.svg" alt="" />
        </a>

        <div className="nav-control">
            <div className="hamburger">
                <span className="line"></span><span className="line"></span><span className="line"></span>
            </div>
        </div>
    </div>
}

export default NavHeader